import { Platform } from 'react-native';
import { moderateScale } from '../Utils/Scaling';
export var fontWeight = {
    regular: '400',
    medium: '500',
    bold: '700',
};
export var newColor = {
    alertInform200: '#008BFF',
    alertInform100: '#F3F6FE',
};
export var color = {
    astronaut: '#2b32b2',
    mariner: '#3a7bd5',
    white: '#ffffff',
    concrete: '#f2f2f2',
    frenchGray: '#c8c7cc',
    mountainMist: '#959399',
    gullGray: '#969db9',
    tuna: '#37383a',
    black: '#000000',
    carnation: '#f44336',
    cinderella: '#FDD9D7',
    lightCarnation: '#FBC6C2',
    buttercup: '#ffbe00',
    fern: '#4bae4f',
    lightFern: '#C9E6CA',
    lightWhite: 'rgba(255,255,255,0.7)',
    overlayOpacity: 'rgba(0,0,0,0.4)',
    darkGray: 'rgba(0,0,0,0.6)',
    darkerGray: 'rgba(50,50,50,1)',
    inactive: '#9B9B9B',
    primary: '#15496C',
    transparent: 'rgba(52, 52, 52, 0)',
    selectedOption: '#bee9e8',
    yellowWarning: '#ffb400',
    gray: '#4A4A4A',
    christine: '#E86A0C',
    shadow: '#b2b2b2',
    gallery: '#EBEBEB',
    clearDay: '#F0FFFC',
    doveGray: '#737373',
    graniteGray: '#666666',
    mineShaft: '#212121',
    darkCharcoal: '#333333',
    tundora: '#484848',
    dodgerBlue: '#577FFE',
    cornflowerBlue: '#3958FE',
    alto: '#E0E0E0',
    silverChalice: '#ADADAD',
    selago: '#F3F6FE',
    monza: '#DF0035',
    hawkesBlue: '#E1E8FD',
    yellowOrange: '#FDAC42',
    wildSand: '#F6F6F6',
    orange1: '#F2994A',
    microposeRed: '#F0102B',
    epicureanOrange: '#F16D0D',
    hedgeGarden: '#0AA781',
    cloudedBlue: '#1F6EFE',
};
export var fontSize = {
    extraSmall: moderateScale(10),
    small: moderateScale(12),
    medium: moderateScale(14),
    medium2: moderateScale(16),
    large: moderateScale(17.5),
    extraLarge: moderateScale(21),
    xxLarge: moderateScale(31.5),
    subHeadline: moderateScale(42),
    headline: moderateScale(70),
};
export var lineHeight = {
    base: 1,
    title: 1.25,
    copy: 1.5,
};
/**
 * React Native and React have different implementation for font.
 * In React, we need to specify the font weight
 * This variable will be a guideline on when to add font weight
 * copy = fontWeight.medium
 * title = fontWeight.bold
 * regular = fontWeight.regular
 */
var isReactNative = Platform.OS !== 'web';
// TODO: to update for react native to use deviceLocale to detect language
// Update once we move getDeviceLocale to the sharedPackages
export var fontFamily = {
    copy: isReactNative ? 'Inter18pt-Medium' : 'Inter, Noto Sans Thai, Noto Sans TC, sans-serif',
    title: isReactNative ? 'Inter18pt-Bold' : 'Inter, Noto Sans Thai, Noto Sans TC, sans-serif',
    regular: isReactNative ? 'Inter18pt-Regular' : 'Inter, Noto Sans Thai, Noto Sans TC, sans-serif',
};
export var spacing = {
    extraSmall: moderateScale(4),
    small: moderateScale(8),
    small2: moderateScale(12),
    medium: moderateScale(16),
    medium2: moderateScale(24),
    medium3: moderateScale(28),
    large: moderateScale(32),
    large2: moderateScale(48),
    extraLarge: moderateScale(64),
};
